var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.AssociationBusinessInformation"),
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { padding: "0 0 5px 0" } }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("SeaExport.BusinessNo")) +
                  "：" +
                  _vm._s(_vm.aData.bNo) +
                  " " +
                  _vm._s(_vm.$t("SeaExport.BusinessStatus")) +
                  "：" +
                  _vm._s(_vm.BusinessStatus) +
                  " "
              )
            ])
          ]),
          _c("div", { staticStyle: { padding: "0 0 5px 0" } }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("SeaExport.CargoQuantityDescription")) +
                  "：" +
                  _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                  " " +
                  _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                  "：" +
                  _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                  " " +
                  _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                  "：" +
                  _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                  " " +
                  _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                  "：" +
                  _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                  " "
              )
            ])
          ]),
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.aData.lob === _vm.job.lob
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "SynchronizedSetting" },
                      on: { click: _vm.showSynchronizedSettingDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Setting")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "1" },
                  on: { click: _vm.addEventHander }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "2" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("synchronized-fields-window", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.synchronizedDialog.visible,
            expression: "synchronizedDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.synchronizedDialog.visible,
          "container-info": _vm.synchronizedDialog.containerInfo,
          "defalut-all-true": _vm.aData.lob !== _vm.job.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.synchronizedDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }